import './index.scss';

const Preloader = function () {
    let loaderContainer = document.body;
    const containerClass = 'ada-preloader__container';
    const loaderClass = 'ada-preloader__img-container';
    const loaderClassSm = 'ada-preloader--sm';
    const loaderClassMd = 'ada-preloader--md';
    const loaderClassLg = 'ada-preloader--lg';
    const loaderImgClass = 'ada-preloader__img';
    let loaderSizeClass = loaderClassSm;
    const loaderSrc = '/nams2020dev/publishingimages/preloader.svg';
    const loaderAlt = 'Loading...';
    let loader = null;

    const getContainer = (container) => {
        if (typeof (container) === 'string') {
            const element = document.querySelector(container);
            return element || document.body;
        }

        return container;
    };

    const setSizeClass = (size) => {
        if (size === 'large') {
            loaderSizeClass = loaderClassLg;
        } else if (size === 'medium') {
            loaderSizeClass = loaderClassMd;
        } else {
            loaderSizeClass = loaderClassSm;
        }
    };

    this.within = (container) => {
        loaderContainer = getContainer(container);
        return this;
    };

    this.havingSize = (size) => {
        size = size || 'small';
        setSizeClass(size);
        return this;
    };

    this.show = () => {
        loader = document.createElement('div');
        loader.classList.add(loaderClass);

        const loaderImg = document.createElement('img');
        loaderImg.setAttribute('src', loaderSrc);
        loaderImg.setAttribute('alt', loaderAlt);
        loaderImg.classList.add(loaderSizeClass, loaderImgClass);

        loader.appendChild(loaderImg);

        loaderContainer.appendChild(loader);

        loaderContainer.classList.add(containerClass);
    };

    this.hide = () => {
        if (loader && loader.parentNode) {
            loader.parentNode.removeChild(loader);
        }

        loaderContainer.classList.remove(containerClass);
    };
    this.IframeIdRemove = function (iframe) {
        if (iframe.src.indexOf('ondemand.org') > 0) {
            document.getElementsByTagName("iframe")[0].removeAttribute("id");
            document.getElementsByTagName("iframe")[0].style.height = "1000px";
            document.getElementsByTagName("iframe")[0].style.overflow = "auto";
        }
    };

};

export default Preloader;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Preloader/index.js